module.exports = __webpack_public_path__ + "kids.png?dcfcbc41332776a001e3af45aa6c9c4e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kids.png
// module id = 55
// module chunks = 0